var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button btn-cv text-none",class:_vm.btnClass,attrs:{"dark":"","to":_vm.toLink}},[_c('span',{staticClass:"aar-btn"},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }